import { useEffect, useState } from 'react';
import { Chip } from '../../../../core/components/atoms/Chip';
import { TPAContentType } from '../../model/dailySchedule';
import { useDailyScheduleContentStore } from '../../stores/useDailyScheduleContent';
import { TDisciplina } from '../../model/configuration';

interface IContentTypeFilterProps {
  value: TPAContentType;
  onChange: (value: TPAContentType) => void;
}

export function ContentTypeFilter({
  value,
  onChange,
}: IContentTypeFilterProps) {
  const selectedDiscipline = useDailyScheduleContentStore(
    (state) => state.selectedDiscipline
  );

  const contentList = useDailyScheduleContentStore(
    (state) => state.contentList
  );

  const [selectedContentType, setSelectedContentType] =
    useState<TPAContentType>();
  const [isEssay, setIsEssay] = useState(false);

  useEffect(() => {
    if(contentList && contentList.length > 0 && selectedDiscipline === 'redacao') {
      setIsEssay(contentList.some(content => content.type === 'essay'));
    }
  }, [contentList, selectedDiscipline]);

  useEffect(() => {
    setSelectedContentType(value);
  }, [value]);

  useEffect(() => {
    if (selectedContentType) {
      onChange(selectedContentType);
    }
  }, [selectedContentType]);

  return (
    <div className='flex flex-row flex-wrap items-center gap-lg'>
      <Chip
        radius='pill'
        variant='alterColor'
        color={selectedDiscipline as TDisciplina}
        onClick={() => setSelectedContentType('all')}
        active={selectedContentType === 'all'}
      >
        Todos
      </Chip>
      <Chip
        radius='pill'
        variant='alterColor'
        color={selectedDiscipline as TDisciplina}
        onClick={() => setSelectedContentType('lesson')}
        active={selectedContentType === 'lesson'}
      >
        Videoaulas
      </Chip>
      {selectedDiscipline !== 'redacao' && (
        <>
          <Chip
            radius='pill'
            variant='alterColor'
            color={selectedDiscipline as TDisciplina}
            onClick={() => setSelectedContentType('exercise')}
            active={selectedContentType === 'exercise'}
          >
            Exercícios
          </Chip>
          <Chip
            radius='pill'
            variant='alterColor'
            color={selectedDiscipline as TDisciplina}
            onClick={() => setSelectedContentType('material')}
            active={selectedContentType === 'material'}
          >
            Materiais
          </Chip>
        </>
      )}
      {selectedDiscipline === 'redacao' && isEssay && (
        <Chip
          radius='pill'
          variant='alterColor'
          color={selectedDiscipline}
          onClick={() => setSelectedContentType('essay')}
          active={selectedContentType === 'essay'}
        >
          Enviar Redação
        </Chip>
      )}
    </div>
  );
}

